<script lang="ts">
    import { mdiCartCheck } from "@mdi/js"
    import { getCart } from "../../../functions/CommerceAPIs/bigCommerce/cart"
    import { getCookie } from "../../../functions/utils"
    import Icon from "../../widgets/Icon.svelte"
    import CartProducts from "./CartProducts.svelte"
    import { spaLink } from "../../../actions"

    const cartId = getCookie("cartId")
    let cart: BKDFCart | null
    async function setCart(id: string) {
        cart = await getCart(id)
    }
    if (cartId) setCart(cartId)
    //"/checkout?checkoutURL={encodeURIComponent(cart.checkoutUrl)}"
</script>

{#if cart}
    <div class="product-listing-wrapper">
        <section class="product-listing-inner">
            <CartProducts
                bind:cart="{cart}"
                on:removeCart="{() => (cart = null)}"
            />
        </section>
    </div>
    <section class="cart-summary">
        {#if Number(cart.cost.discountedAmount.amount) > 0}
            <div class="discount">
                <div>Rabatt</div>
                <div>-{cart.cost.discountedAmount.amount}{cart.cost.discountedAmount.currencyCode}</div>
            </div>
        {/if}
        <div class="total">
            <em>Gesamt</em>
            <div>{cart.cost.amount.amount}{cart.cost.amount.currencyCode}</div>
        </div>
        <a
            class="checkout"
            use:spaLink
            href="/checkout?checkoutURL={encodeURIComponent(cart.checkoutUrl)}"
            ><Icon path="{mdiCartCheck}" /> <span>Zur Kasse</span></a
        >
    </section>
{:else}
    <p>No items in cart</p>
{/if}

<style lang="less">
    .product-listing-wrapper {
        overflow-y: auto;
        max-height: calc(100% - 154px);

        &::-webkit-scrollbar {
            width: 11px !important;
        }

        &::-webkit-scrollbar-thumb {
            background: var(--bg-100) !important;
        }

        &::-webkit-scrollbar-track {
            background: rgba(13, 12, 12, 0.25) !important;
            border-left: 3px solid transparent !important;
            border-right: 3px solid transparent !important;
            background-clip: padding-box !important;
        }
        padding-right: 59px;
        width: 100%;

        flex-grow: 1;
        .product-listing-inner {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 24px 0px;
        }
    }
    .cart-summary {
        display: flex;
        height: 225px;
        flex-direction: column;
        padding: 24px 0px;
        border-top: 1px solid var(--text-300);
        height: fit-content;
        .discount,
        .total {
            padding: 12px 24px;
            width: 100%;
            display: flex;
            justify-content: space-between;
            &.discount {
                border-bottom: 1px solid var(--text-300);
            }
            &.total {
                background-color: var(--bg-100);
                color: var(--neutral-white);
                em {
                    font-weight: 700;
                    font-size: 1rem;
                    line-height: 0.7rem;
                }
            }
        }
        .checkout {
            width: 100%;
            padding: 12px 24px;
            font-weight: 700;
            color: var(--neutral-white);
            font-size: 1rem;
            line-height: 0.7rem;
            background-color: var(--primary-100);
            box-shadow: 0px -2px 0px 0px rgba(0, 0, 0, 0.25);
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10px;
            margin: 35px 0px;
            border-radius: 5px;
        }
    }
</style>
